export default __webpack_public_path__ + "static/media/compas_user_grant.241dd4a4.gif";